import { initializeApp } from 'firebase/app';
import { CONFIG } from 'constants/index';

export const app = initializeApp(CONFIG.firebase);
